/** @jsx jsx */
import { jsx } from "theme-ui"
import Card from "./card"

const ColumnLayoutCard = ({ content, ...restProps }) => {
  return (
    <div sx={{ color: "inherit" }}>
      {content.contentCards &&
        content.contentCards.map(subcard => <Card content={subcard} />)}
    </div>
  )
}

export default ColumnLayoutCard
